
<div class="row" *ngIf="loadingRecentRequisitionsFlag">
    <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let placeholder of [1, 2, 3]">
        <div class="main-box clearfix project-box emerald-box">
            <div class="main-box-body clearfix" style="height:260px;">
                <div class="p-3 d-flex flex-column justify-content-between skeleton-container" style="height:100%;">
                    <div class="d-flex flex-column skeleton-container">
                        <div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
                        <div class="skeleton-paragraph width-50 skeleton-loading"></div>
                    </div>
                    <div class="d-flex justify-content-between skeleton-container">
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                    </div>
                    <div class="d-flex justify-content-between skeleton-container">
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                    </div>
                    <div class="d-flex justify-content-between skeleton-container">
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center skeleton-container">
                        <div class="skeleton-paragraph width-50 skeleton-loading"></div>
                        <div class="skeleton-heading width-25 skeleton-loading my-0"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" [hidden]="loadingRecentRequisitionsFlag">
    <div class="col-lg-4 col-md-6 col-sm-6"  *ngFor="let req of requisitions">
        <app-requisition-card
            [requisitionInfo]="req"
            [activityMap]="activityMap"
            [salaryDurationOptions]="salaryDurationOptions"
            (deleteCallback)="deleteRequisition(req)"
            (copyCallback)="copyRequisition()">
        </app-requisition-card>
    </div>
</div>
<div class="requisition_not_found d-flex flex-column" [hidden]="loadingRecentRequisitionsFlag"
    *ngIf="requisitions?.length === 0">
    <span class="mb-3">
        No requisitions available!
    </span>
    <img src="assets/app-content/img/no_requisitions.svg" style="height:180px" alt="No Candidates Found">
</div>